import { kebabCase } from 'es-toolkit'

import type { FirebaseApp } from 'firebase/app'
import { collection, doc, getDoc, getFirestore, serverTimestamp, setDoc } from 'firebase/firestore'

// object[] covers structured values (e.g. an array of custom-group objects) that individual
// apps may want to persist alongside the plain scalar/array prefs.
type PrefValue = string | number | boolean | string[] | number[] | boolean[] | object[]

export class UserPrefs {
  private _app: FirebaseApp

  private _uid: string
  private _key: string

  private _prefs: Record<string, PrefValue> = {}

  public constructor(app: FirebaseApp, uid: string, key: string) {
    this._app = app
    this._uid = uid

    this._key = kebabCase(key)
  }

  public get data() {
    return this._prefs
  }

  public async load() {
    const db = getFirestore(this._app)

    const docRef = doc(collection(db, `account-prefs/${this._uid}/service-prefs`), this._key)

    this._prefs = (await getDoc(docRef)).data() || {}

    return this._prefs
  }

  public async save(prefs: Record<string, PrefValue>) {
    const db = getFirestore(this._app)

    this._prefs = { ...this._prefs, ...prefs }

    const docRef = doc(collection(db, `account-prefs/${this._uid}/service-prefs`), this._key)

    await setDoc(docRef, { ...this._prefs, updatedAt: serverTimestamp() }, { merge: true })
  }
}
